import React, { useEffect, useState } from 'react';
import { useCreate, useNavigation, useOne } from '@refinedev/core';
import AuthRequestService from './AuthRequestService';
import {
  Container,
  Title,
  Button,
  Group,
  Text,
  Center,
  Stack,
} from '@mantine/core';
import PageLoader from '../../UI/loader/PageLoader';

type Job = {
  id: string;
  status: string;
  statusMessage: string;
};

function useDebouncedEffect(delay: number, effect: () => void) {
  useEffect(() => {
    const timeout = setTimeout(effect, delay);
    return () => clearTimeout(timeout);
  }, []);
}

export const CompleteConnectionFlowPage = () => {
  const { push } = useNavigation();
  const [allowPolling, setAllowPolling] = useState(true);
  const { mutate, data: createConnectionResponse, isError } = useCreate<Job>();

  const { data: job } = useOne<Job>({
    resource: 'connections-jobs',
    id: createConnectionResponse?.data?.id,
    queryOptions: {
      enabled: !!createConnectionResponse?.data?.id && allowPolling,
      refetchInterval: 2000,
    },
  });

  useDebouncedEffect(300, () => {
    completeConnectionFlow();
  });

  useEffect(() => {
    if (job?.data?.status === 'SUCCESS') {
      setAllowPolling(false);
      push('/');
    }
    if (job?.data?.status === 'FAILED') {
      setAllowPolling(false);
    }
  }, [job, push]);

  async function completeConnectionFlow() {
    const u = new URL(window.location.href);
    const code = u.searchParams.get('code');
    const state = u.searchParams.get('state');
    const idToken = u.searchParams.get('id_token');
    const authRequestId = AuthRequestService.getAuthRequestId();
    mutate({
      resource: 'connections',
      values: { code, state, idToken, authRequestId },
    });
  }

  return job?.data?.status === 'FAILED' || isError ? (
    <Container>
      <Title ta="center" mt={'xxl'}>
        Provider connection failed...
      </Title>
      <Text c="dimmed" size="lg" ta="center" mt={'xs'}>
        We have encountered an error while connecting to the provider. Please go
        back and try again.
      </Text>
      <Group justify="center" mt={'xxl'}>
        <Button onClick={() => push('/')}>Back</Button>
      </Group>
    </Container>
  ) : (
    <Center>
      <Stack>
        <PageLoader />
        <Text>{job?.data?.statusMessage || 'configuring...'} </Text>
      </Stack>
    </Center>
  );
};
